jQuery_T4NT(document).ready(function ($) {
  function matchHeight(element) {
    var maxHeight = 0;
    $(element).each(function () {
      $(this).css('height', 'auto');
      if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
    });
    $(element).height(maxHeight);
  }

  $('.js-collectionReadMore').click(function () {
    event.preventDefault();
    $('.js-collectionReadMoreContent').slideToggle();
  });

  $(document.body).on('change', '#tradeTermsConditions', function () {
    if ($(this).is(":checked")) {
      $('#signupTrade').removeAttr('disabled');
    } else {
      $('#signupTrade').attr('disabled', 'disabled');
    }
  });

  $(document.body).on('click', '#menu_mb_ul li:first-of-type a', function () {
    if ($(this).text() == 'Shop For') {
      $('.mb_nav_title').first().removeClass('active');
      $('.mb_nav_tab').first().removeClass('active');
      $('.mb_nav_title:eq(1)').addClass('active');
      $('.mb_nav_tab:eq(1)').first().addClass('active');
    }
  });

  if ($('body').hasClass('template-customers-register')) {
    var current_url = window.location.href;
    var trade_register = $('#registerTrade').html();
    var customer_register = $('#registerCustomer').html();
    const register_place = localStorage.getItem('register-place');
    if (register_place && document.referrer.indexOf('challenge') !== -1) {
      if (register_place == 'customer') {
        if (current_url.indexOf("customer-account") === -1) {
          window.location.href = window.location.href + '#customer-account';
        }
        $('#registerPageForm').html(customer_register);
      } else if (register_place == 'trade') {
        if (current_url.indexOf("trade-account") === -1) {
          window.location.href = window.location.href + '#trade-account';
        }
        $('#registerPageForm').html(trade_register);
      }
    } else {
      if (current_url.indexOf("trade-account") >= 0) {
        localStorage.setItem('register-place', 'trade');
        $('#registerPageForm').html(trade_register);
      } else if (current_url.indexOf("customer-account") >= 0) {
        localStorage.setItem('register-place', 'customer');
        $('#registerPageForm').html(customer_register);
      }
    }
  }

  if ($('body').hasClass('page_id_52121534639')) {
    $(window).on('load resize', function () {
      matchHeight('.where-to-buy-logo');
    });
  }

  if ($('.article-product-info').length) {
    $(window).on('load resize', function () {
      matchHeight('.article-product-info .product-title');
    });
  }

  function showPrices() {
    $('body').addClass('gb-available');
  }

  // $.get("https://ipapi.co/" + userIP +  "/json/", function (response) {
  //   console.log(response.country);
  //   if (response.country == 'GB') {
  showPrices();
  //   }
  // }, "jsonp");
  $('.read-more').on('click', function () {
    $('.sp-tabs .tab-heading')[0].click();
    $('html, body').animate({
      scrollTop: $('.sp-tab').offset().top
    }, 1000);
  });
});

